var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"calendar-week"},_vm._l(((_vm.weeks)),function(item,index){return _c('div',{key:item,staticClass:"calendar-week-item",class:({'calendar-week-holiday': item === '六' || item === '日'})},[_vm._v(_vm._s(item))])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }